import { Handle, Position } from 'reactflow';
import React from 'react';
import { styled } from '@mui/material/styles';

const HiddenHandle = styled(Handle)({
  display: 'none',
});

export function LoopHandles() {
  return (
    <>
      <HiddenHandle type="target" position={Position.Top} isConnectable={false} />
      <HiddenHandle type="source" position={Position.Top} isConnectable={false} />
    </>
  );
}
